import { actionList } from '@/modules/FileDetail/data/actionList/actionList';
import { actionListQueryFunction } from '@/modules/FileDetail/queries/actionList/actionListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const actionListQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['action_list', id],
    queryFn: () => actionListQueryFunction(id),
    enabled: !!id,
    select(data) {
      return actionList.filter((action) => data[action.value]);
    },
  });
